import React, { useRef, useEffect } from 'react';
import useMediaStreamTrack from '../hooks/useMediaStreamTrack';

export default function VideoTrack({ track, isLocal, priority, className }) {
  const ref = useRef(null);
  const mediaStreamTrack = useMediaStreamTrack(track);

  useEffect(() => {
    const el = ref.current;
    el.muted = true;
    if (track.setPriority && priority) {
      track.setPriority(priority);
    }
    track.attach(el);
    return () => {
      track.detach(el);
      if (track.setPriority && priority) {
        // Passing `null` to setPriority will set the track's priority to that which it was published with.
        track.setPriority(null);
      }
    };
  }, [track, priority]);

  // The local video track is mirrored if it is not facing the environment.
  const isFrontFacing = mediaStreamTrack?.getSettings().facingMode !== 'environment'; 

    return <video ref={ref} className={track.name === "screen" ? "screen-track":""}
        style={{
            width: '100%',
            height: '100%',
            //objectFit: 'contain',
            transform: isLocal && isFrontFacing ? 'rotateY(180deg)' : '',
        }} />;
}
